import * as React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

export default function CommentDrawer({ open, setOpen, children,width=null }) {
    return (
        <div>
            <React.Fragment>
                <SwipeableDrawer
                    anchor='right'
                    open={open}
                    onClose={() => { setOpen(false) }}
                    onOpen={() => { setOpen(true) }}
                    sx={{
                        '& .MuiDrawer-paper': {
                            width: {
                                xs: '100%',
                                sm: '75%',
                                md: '50%',
                                lg: width?width:'35%',
                            },
                        },
                    }}
                >
                    {children}
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    );
}
